import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

export default function MemberRoute({ children }) {
  const { user, isAdmin, isApproved, loading } = useAuth();

  if (loading) return null;

  // Not logged in → go to login
  if (!user) return <Navigate to="/login" replace />;

  // Admin always gets access
  if (isAdmin) return children;

  // Approved member gets access
  if (isApproved) return children;

  // Pending or rejected → go to dashboard to see status
  return <Navigate to="/dashboard" replace />;
}
